import { Component, OnInit, OnDestroy } from '@angular/core';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {Subscription} from 'rxjs';

export interface LoaderSubjectInf {
  show: boolean ;
  customColor?: boolean;

}

@Component({
  selector: 'arm-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  isLoading: LoaderSubjectInf;
  subscription: Subscription;
  constructor(private loaderService: LoaderService) { }



  ngOnInit(): void {
      this.subscription = this.loaderService.isLoading.subscribe((data) => {
        this.isLoading = data;
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }



}
